import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect, createRef } from 'react'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Card from '../../usables/small/Card'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Select from 'react-select'
import { TrashIcon } from '@heroicons/react/outline'

export default function  Teacher() {
  const { id } = useParams()
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [teacher, setTeacher] = useState({})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  const [formDataC, setFormDataC] = useState({teacher_id: id, class_id: ''})
  const [formDataS, setFormDataS] = useState({teacher_id: id, subject_id: ''})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)
  const [classList, setClassList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const modal = createRef()


  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const updatePerson = () => {
    axios.patch(process.env.REACT_APP_API + `/people/${teacher.person.id}`, formData, config)
      .then((res)=>{
        if(res.status === 200){
          var teach = {...teacher}
          teach.person = res.data.person
          setTeacher(teach)
        }
      })
    }

  const updateSubject = () => {
    axios.post(process.env.REACT_APP_API + '/teacher/attachsubject', formDataS, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  const removeSubject = () => {
    axios.post(process.env.REACT_APP_API + '/teacher/detachsubject', formDataS, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
    }

  const updateClass = () => {
    axios.post(process.env.REACT_APP_API + '/class/teacher', formDataC, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/teacher/${id}`, config)
    .then(res => {
      if(res.status === 200){
        setTeacher(res.data.teacher)
        setFormData({name: res.data.teacher.person.name, lastname: res.data.teacher.person.lastname, email: res.data.teacher.person.email, phone: (res.data.teacher.person.phone === null) ? '' : res.data.teacher.person.phone})
        setDataLoaded({done: true, sucssess: true, items: 1})
      }
      axios.get(process.env.REACT_APP_API + '/class', config)
      .then(res => {
        if(res.status === 200){
          setClassList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            if (data.teacher_id === null) {
              setClassList(classes => [...classes, data])
            }
          })
        }
      })
      .catch(err => {
        setClassList([]) //! Pašalinti prieš buildinant
        setClassList(classes => [...classes, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
      axios.get(process.env.REACT_APP_API + '/subject', config)
      .then(res => {
        if(res.status === 200){
          setSubjectList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setSubjectList(subjects => [...subjects, data])
          })
        }
      })
      .catch(err => {
        setSubjectList([]) //! Pašalinti prieš buildinant
        setSubjectList(subjects => [...subjects, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
    })
    .catch(err => {
      //console.log(err.response.data)
      setTeacher(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    {dataLoaded.sucssess ? <h2>{teacher.person.name + ' ' + teacher.person.lastname}</h2> : null}
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
            {/* {JSON.stringify(teacher)} */}
            <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
              <Card title='Pagrindinė informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Vardas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {teacher.person.name}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pavardė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {teacher.person.lastname}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          El. paštas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(teacher.person.email !== null) ? teacher.person.email : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate "> {/* dark:text-white */}
                          Telefonas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 "> {/* dark:text-white */}
                        {(teacher.person.phone !== null) ? teacher.person.phone : 'nėra'}
                      </div>
                    </div>
                  </li>
                </ul>
                {authUser().roles.admin &&
                <Modal btnText='Redaguoti' title='Redaguoti' saveText='Išsaugoti' submitFunction={() => updatePerson()}>
                  <div className='pt-5'>
                    <Input
                      label='Vardas'
                      name='name'
                      type='text'
                      value={formData.name}
                      onChange={(e)=>setFormData({...formData, name: e.target.value})}
                      />
                    <Input
                      label='Pavardė'
                      name='lastname'
                      type='text'
                      value={formData.lastname}
                      onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
                      />
                    <Input
                      label='El. paštas'
                      name='email'
                      type='email'
                      value={formData.email}
                      onChange={(e)=>setFormData({...formData, email: e.target.value})}
                      />
                    <Input
                      label='Telefonas'
                      name='phone'
                      type='tel'
                      value={formData.phone}
                      onChange={(e)=>setFormData({...formData, phone: e.target.value})}
                      />
                  </div>
                </Modal>}
              </Card>
              <Card title='Papildoma informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Klasė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(teacher.student_class !== null) ? <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/classes/' + teacher.student_class.id}>{teacher.student_class.name}</Link> : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-start space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Mokomasis dalykas
                        </p>
                      </div>
                      <div className="text-base text-right font-semibold text-gray-900 ">
                        {(teacher.subject.length !== 0) 
                          ? teacher.subject.map(subj => {
                            return (<div key={subj.id} className='flex gap-1 justify-end'>
                              <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/subjects/' + subj.id}>{subj.subject_name}</Link>
                              {authUser().roles.admin &&
                              <TrashIcon 
                              className='flex-shrink-0 h-6 w-6 cursor-pointer text-danger-500 hover:text-danger-900' 
                              onClick={() => {
                                setFormDataS({...formDataS, subject_id: subj.id})
                                modal.current.updateShow()
                              }} />
                              }
                            </div>)
                          })
                          : 'nėra'
                        }
                      </div>
                    </div>
                  </li>
                  
                </ul>
                {authUser().roles.admin && 
                <div className='flex gap-4 justify-center'>
                  <Modal btnText='Keisti klasę' title='Keisti klasę' saveText='Išsaugoti' submitFunction={() => updateClass()}>
                    <div className='pt-5'>
                    <label htmlFor="class">Klasė</label>
                    <Select 
                      name='class'
                      onChange={(e)=>setFormDataC({...formDataC, class_id: e.value})} 
                      defaultValue={(teacher.student_class !== null) ? {value: teacher.student_class.id, label: teacher.student_class.name} : null} 
                      options={
                      classList.map(classo => {
                        return ({ value: classo.id, label: classo.name })
                      })
                    } />
                    </div>
                  </Modal>
                  <Modal btnText='Pridėti dalyką' title='Pridėti dalyką' saveText='Išsaugoti' submitFunction={() => updateSubject()}>
                    <div className='pt-5'>
                    <label htmlFor="class">Mokomasis dalykas</label>
                    <Select 
                      name='class'
                      onChange={(e)=>setFormDataS({...formDataS, subject_id: e.value})} 
                      defaultValue={(teacher.subject.length !== 0) ? {value: teacher.subject[0].id, label: teacher.subject[0].subject_name} : null} 
                      options={
                        subjectList.map(subject => {
                        return ({ value: subject.id, label: subject.subject_name })
                      })
                    } />
                    </div>
                  </Modal>
                </div>}
              </Card>
            </div>
            {authUser().roles.admin && 
            <Modal title='Naikinti?' saveText='Naikinti' noBtn ref={modal} submitFunction={() => removeSubject()}>
              <p>Ar norite panaikinti šį mokomąjį dalyką?</p>
            </Modal>}
          </>
          : <ClosingAlert type='warning' message='Nerasta jokia informacija' />
        : <ClosingAlert type='error' message='Mokytojas nerastas' />
      }
    </>
  )
}